import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { SiteLanguage } from 'modules/common/components';
import { Row, Col } from 'modules/bootstrap/components';

// please replace the image of the background and logo with your own, but dont change their names
import authBg from 'images/two-column-page-bg-1.png';
import logo from 'images/logo.svg';

type NotFoundPageProps = {
  isInvalidEmailToken: boolean;
};

export default function NotFoundPage(props: NotFoundPageProps) {
  const { isInvalidEmailToken } = props;
  const { t } = useTranslation(['auth']);

  return (
    <>
      <img
        src={authBg}
        className="Decoration Decoration--authentication"
        alt="Authorization pages background image"
      />
      <main className="t-min-h-screen t-bg-gamma-400 t-p-3 lg:t-p-0">
        <Row className="t-w-full">
          <Col
            lg={{ span: 6, offset: 6 }}
            md={{ span: 8, offset: 2 }}
            className="u-h-100"
          >
            <div className="Form Form--authentication u-h-100">
              <SiteLanguage additionalClass="t-flex t-justify-end" />
              <img src={logo} alt="Client logo" className="t-pb-7" />

              <h1 className="Typography Typography--title t-pb-5 u-weight-600">
                {isInvalidEmailToken
                  ? t('auth:invalid_email_token_title')
                  : t('auth:not_found_title')}
              </h1>

              <p className="Typography Typography--subTitle u-pb-30">
                {isInvalidEmailToken
                  ? t('auth:invalid_email_token_description')
                  : t('auth:not_found_description')}
              </p>
              <Link
                className="Button Button--secondary d-inline-flex"
                to={isInvalidEmailToken ? 'login' : '/'}
              >
                {isInvalidEmailToken
                  ? t('auth:go_to_login')
                  : t('auth:go_home')}
              </Link>
            </div>
          </Col>
        </Row>
      </main>
    </>
  );
}
